var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7474 20.4546C18.5096 20.4546 17.5034 21.4727 17.5034 22.7273C17.5034 23.9818 18.5096 25 19.7474 25C20.9861 25 21.9914 23.9818 21.9914 22.7273C21.9914 21.4727 20.9861 20.4546 19.7474 20.4546ZM8.07851 20.4546C6.84071 20.4546 5.83449 21.4727 5.83449 22.7273C5.83449 23.9818 6.84071 25 8.07851 25C9.31721 25 10.3225 23.9818 10.3225 22.7273C10.3225 21.4727 9.31721 20.4546 8.07851 20.4546ZM6.14327 16.3637H21.8128C22.6144 16.3637 23.2975 15.7773 23.4294 14.9773C23.7337 13.1291 24.6268 7.70097 24.9778 5.56916C25.0568 5.08735 24.923 4.59553 24.6116 4.22371C24.3001 3.85099 23.8432 3.63644 23.3612 3.63644H5.48173L5.44672 2.9619C5.38927 1.85554 4.62451 0.915544 3.56264 0.646454C2.51154 0.381 1.11576 0.0273653 1.11576 0.0273653C0.635542 -0.0944524 0.147243 0.20191 0.026964 0.688272C-0.0933155 1.17554 0.200202 1.66918 0.680423 1.79099L3.1273 2.41099C3.42441 2.48554 3.63804 2.74826 3.6542 3.05826L4.41088 17.6282C4.48 18.9573 5.56521 20 6.8802 20H21.0938C21.5893 20 21.9914 19.5927 21.9914 19.0909C21.9914 18.5891 21.5893 18.1818 21.0938 18.1818H6.8802C6.52026 18.1818 6.22315 17.8964 6.2043 17.5328L6.14327 16.3637V16.3637Z",
    fill: "url(#paint0_linear_167_3600)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_167_3600",
    x1: -3.26087,
    y1: -1.26758e-8,
    x2: 25,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7670CF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/CartIcon.38bd57df7fdab335b55bffd00b68a645.svg";
export { ForwardRef as ReactComponent };